{
    "PageTitle": "Rezerwacja sal konferencyjnych / hotdesk",
    "location": "Wybierz lokalizację / pokój",
    "date": "Data",
    "from_date": "Od daty",
    "to_date": "Do daty",
    "toDateError": "'Do daty' musi być równa lub późniejsza niż 'Od daty', a maksymalna różnica między datami wynosi 30 dni.",
    "topic": "Temat",
    "timeFrom": "Czas rozpoczęcia",
    "timeUntil": "Czas zakończenia",
    "startTime": "Czas rozpoczęcia",
    "capacity": "Ile osób będzie uczestniczyć?",
    "btnSubmit": "Wyślij",
    "btnReset": "Resetuj",
    "formReset": "Resetuj formularz",
    "errMsg": "Proszę wypełnić wszystkie pola!",
    "inputPlaceholder": "wprowadź...",
    "hours": "godziny",
    "minutes": "minuty",
    "starting": "Rozpoczęcie",
    "duration": "Czas trwania",
    "btnSearch": "Szukaj",
    "locationOptionLabel": "Lokalizacja, Nazwa pokoju / Numer",
    "startOptionLabel": "Wybierz czas rozpoczęcia",
    "durationOptionLabel": "Wybierz czas trwania",
    "capacityOptionLabel": "Wybierz pojemność",
    "searchText": "proszę czekać, próbujemy połączyć się z serwerem!",
    "dummyLocationValueOne": "Lokalizacja 1",
    "dummyLocationValueTwo": "Lokalizacja 2",
    "roomAvailableTextDummy": "Znaleziono 27 przestrzeni na 24 kwietnia, 13:00 - 14:00 na Hallstadter Straße 119 - Schulungsgebäude",
    "roomAvailableFound": "Znaleziono",
    "roomAvailableSpaces": "przestrzenie w",
    "roomAvailablein": "w",
    "floorDropdownDummy": " EG Schulungsgebäude",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Lokalizacja spotkania",
    "titleOfMeetingLabel": "Tytuł spotkania",
    "titleOfMeetingPlaceholder": "Wprowadź tytuł lub temat planowanego spotkania",
    "descOfMeetingPlaceholder": "Dodaj opis",
    "meetingDescriptionLabel": "Opis spotkania (opcjonalnie)",
    "availableLabel": "Dostępny",
    "busyLabel": "Zajęty",
    "confirmBookingBtn": "Potwierdź rezerwację",
    "bookingSuccessLabel": "Rezerwacja pokoju zakończona sukcesem",
    "bookingFailureLabel": "Coś poszło nie tak. Spróbuj ponownie później.",
    "selectRoomLocation": "Wybierz lokalizację / pokój",
    "futureDateError": "Proszę wybrać poprawną przyszłą datę/czas.",
    "noSlotAvailable": "Brak dostępnych miejsc",
    "tokenRequired": "Brak lub wygasł wymagany token dostępu.",
    "roomBooked": "Pokój jest już zarezerwowany!",
    "roomPartiallyBooked": "Pokój jest częściowo zarezerwowany!",
    "participantError": "Planujesz zarezerwować dla ",
    "participantErrorMsg": " uczestników, jednak pojemność pokoju wynosi tylko ",
    "partiallyFree": "Częściowo wolny",
    "startingTime": "Czas rozpoczęcia",
    "participants": "Liczba uczestników",
    "max": "Maks",
    "capacityLabel": "Pojemność ",
    "dashboard": "Pokaż moje rezerwacje",
    "manageBookings": "Zarządzaj rezerwacjami",
    "bookAgain": "Zarezerwuj ponownie",
    "cancelBookingConfrim": "Czy na pewno chcesz anulować to spotkanie?",
    "list": "Lista",
    "search": "Szukaj",
    "type": "Typ",
    "updateBookingApiSucessMsg": "Rezerwacja zaktualizowana pomyślnie",
    "rebookingApiSucessMsg": "Zarezerwowano pomyślnie",
    "cancelBookingApiSucessMsg": "Rezerwacja anulowana pomyślnie",
    "noUpcomingBooking": "Obecnie nie masz żadnych nadchodzących rezerwacji",
    "noPastBooking": "Obecnie nie masz żadnych przeszłych rezerwacji",
    "apiFailDefaultMsg": "Coś poszło nie tak. Spróbuj ponownie później.",
    "confirm": "Potwierdź",
    "cancel": "Anuluj",
    "close": "Zamknij",
    "fieldRequired": "To pole jest wymagane",
    "selectLocation": "Proszę wybrać lokalizację",
    "selectDate": "Proszę wybrać datę rezerwacji",
    "meetingTitleMissing": "Brakuje tytułu spotkania",
    "numberOfParticipantMissing": "Brakuje liczby uczestników",
    "gingcoDisclaimer": "MyHelp pomaga w łatwym doświadczeniu rezerwacji pokoju. W przypadku innych usług Gingco (np. Usługi cateringowe) możesz skontaktować się z Gingco.",
    "availability": {
        "text": "Dostępność",
        "free": "Tak, dostępny",
        "busy": "Przepraszamy, niedostępny",
        "busyHint": "Spróbuj zmienić datę lub czas, możesz także sprawdzić pobliskie pokoje",
        "partialFree": "Częściowo wolny pokój",
        "unknown": "Nieznany"
    },
    "manageBooking": {
        "meetingLocation": "Lokalizacja spotkania",
        "reschedule": "Przełóż",
        "bookAgain": "Zarezerwuj ponownie",
        "rescheduleTo": "Przełóż na",
        "cancelMeeting": "Anuluj spotkanie",
        "searchPlaceholder": "Szukaj według ID spotkania, Opisu, Lokalizacji"
    },
    "durationOptions": {
        "15 Min": "15 Min",
        "30 Min": "30 Min",
        "45 Min": "45 Min",
        "1 Hr": "1 Hr",
        "2 Hr": "2 Hr",
        "4 Hr": "4 Hr",
        "8 Hr": "8 Hr"
    },
    "meetingRoomTypes": {
        "All": "Wszystkie",
        "Hot Desk": "Hot Desk",
        "Meeting Room": "Sala spotkań"
    },
    "peopleCount": "Ile osób bierze udział?"
}